import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PageSection } from '@app/pages/MainPage/ValueInclusive/PageSection';

const SECTION_ID = 'video-section';

export const VideoSection: React.FC = () => {
	const ref = React.useRef<HTMLSpanElement>(null);
	const location = useLocation();
	const navigate = useNavigate();

	React.useEffect(() => {
		const hash = location.hash.replace('#', '');
		if (hash !== SECTION_ID) return;

		ref.current?.scrollIntoView();
		navigate({
			pathname: location.pathname,
			search: location.search,
			hash: '',
		}, {
			replace: true,
		});
	}, [location.hash]);

	return (
		<PageSection
			id={SECTION_ID}
			header={(
				<span ref={ref}>
					MORE ENJOYMENT <span className="font-family_decorative font-weight_light text-header__highlight">Less Planning</span>
				</span>
			)}
		>
			<iframe
				src="https://www.youtube.com/embed/MTeGhp9-nr4?si=Mj8gghVOLoox49Gs"
				title="YouTube video player"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerPolicy="strict-origin-when-cross-origin"
				allowFullScreen
				style={{
					border: 'none',
					width: '100%',
					aspectRatio: '16 / 9',
				}}
			/>
			<p className="text-size_medium">
				We’ve packaged the essentials (and a few extras) to make your cruise vacation even better!
				Take a closer look at how we simplify planning and add more to every moment.
			</p>
		</PageSection>
	);
};
